import { state, style, trigger } from '@angular/animations'

export const messageSidebarAnimation = trigger('expanded', [
  state(
    'active',
    style({
      height: 'auto',
      padding: '15px 5px',
      opacity: 1,
    })
  ),
  state(
    'inactive',
    style({
      height: 0,
      padding: 0,
      opacity: 0,
    })
  ),
])
